import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Grid,
  Box,
  useMediaQuery,
  useTheme,
  Tooltip,
} from "@mui/material";
import axiosInstance from "../../../../lib/axios";
import { toast } from "react-toastify";

const VendorAllocationModal = ({
  open,
  onClose,
  vendors,
  searchTerm,
  onSearchChange,
  selectedVendorIds,
  onToggleVendor,
  showAll,
  onToggleShowAll,
  formData,
  currentTktCategoryId,
  setSelectedVendorIds,
  fetchRetriveVendors
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [tempSelectedVendorIds, setTempSelectedVendorIds] = useState([]);

  useEffect(() => {
    if (open) {
      onSearchChange("");
      setTempSelectedVendorIds(selectedVendorIds);
    }
  }, [open, selectedVendorIds, onSearchChange]);

  const handleToggleTempVendor = (vendorId) => {
    setTempSelectedVendorIds((prev) =>
      prev.includes(vendorId)
        ? prev.filter((id) => id !== vendorId)
        : [...prev, vendorId]
    );
  };

  const hasUnsavedChanges = () => {
    const original = new Set(selectedVendorIds);
    const current = new Set(tempSelectedVendorIds);
    if (original.size !== current.size) return true;
    for (let id of original) {
      if (!current.has(id)) return true;
    }
    return false;
  };

  // const handleSave = () => {
  //   if (typeof onToggleVendor === "function") {
  //     tempSelectedVendorIds.forEach((id) => {
  //       if (!selectedVendorIds.includes(id)) {
  //         onToggleVendor(id);
  //       }
  //     });
  //     selectedVendorIds.forEach((id) => {
  //       if (!tempSelectedVendorIds.includes(id)) {
  //         onToggleVendor(id);
  //       }
  //     });
  //   }
  //   if (showAll) onToggleShowAll();
  //   onClose();
  // };

  // const handleSave = async () => {
  //   // Replace parent selection with the temporary one
  //   setSelectedVendorIds(tempSelectedVendorIds);
  //   // --------------------------------------------------------------
  //   //  1. Update parent state with the final selection
  //   // --------------------------------------------------------------
  //   setSelectedVendorIds(tempSelectedVendorIds);

  //   // --------------------------------------------------------------
  //   //  2. Call the Manage API **only if we have a category ID**
  //   // --------------------------------------------------------------
  //   if (currentTktCategoryId && tempSelectedVendorIds.length > 0) {
  //     const payload = {
  //       PropWiseServProConfig: tempSelectedVendorIds.map((id) => ({
  //         TktCategoryId: currentTktCategoryId,
  //         ServiceProvId: id,
  //       })),
  //     };

  //     // API expects a *double-escaped* JSON string
  //     let jsonStr = JSON.stringify(payload);
  //     jsonStr = jsonStr.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  //     jsonStr = '"' + jsonStr + '"';

  //     try {
  //       const res = await axiosInstance.post(
  //         `/TktCategory/ManageMstPropWiseServPro`,
  //         jsonStr,
  //       );
  //       const { Status, Message } = res.data;
  //       if (Status === 0 && Message) {
  //         toast.success(Message || "Vendors allocated successfully", { autoClose: 1000 });
  //         await fetchRetriveVendors(currentTktCategoryId);
  //       } else {
  //         toast.error(Message || "Failed to allocate vendors", { autoClose: 1000 });
  //         await fetchRetriveVendors(currentTktCategoryId);
  //       } 
  //     } catch (err) {
  //       console.error("Vendor allocation error:", err);


  //     }
  //   }

  //   if (showAll) onToggleShowAll();
  //   onClose();
  // };

    const handleSave = async () => {
    setSelectedVendorIds(tempSelectedVendorIds);

    if (currentTktCategoryId && tempSelectedVendorIds.length > 0) {
      const payload = {
        PropWiseServProConfig: tempSelectedVendorIds.map((id) => ({
          TktCategoryId: currentTktCategoryId,
          ServiceProvId: id,
        })),
      };

      let jsonStr = JSON.stringify(payload);
      jsonStr = jsonStr.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
      jsonStr = '"' + jsonStr + '"';

      try {
        const res = await axiosInstance.post(
          `/TktCategory/ManageMstPropWiseServPro`,
          jsonStr,
        );
        const { Status, Message } = res.data;

        if (Status === 0) {
         // toast.success(Message || "Vendors allocated successfully", { autoClose: 1000 });
          await fetchRetriveVendors(currentTktCategoryId);
          if (showAll) onToggleShowAll();
          onClose(); // Close only on success
        } else {
          toast.error(Message || "Failed to allocate vendors", { autoClose: 1000 });
           await fetchRetriveVendors(currentTktCategoryId);
          // Do NOT close modal on error (Status === 1)
        }
      } catch (err) {
        const msg = err.response?.data?.Message || "Network error";
        toast.error(msg, { autoClose: 1000 });
        // Do NOT close on network error
      }
    } else {
      // No vendors selected → just close
      if (showAll) onToggleShowAll();
      onClose();
    }
  };

  const handleClose = () => {
    if (hasUnsavedChanges()) {
      const confirmClose = window.confirm(
        "You have unsaved changes. Are you sure you want to close without saving?"
      );
      if (!confirmClose) return;
    }
    onClose();
  };

  const lowerSearchTerm = searchTerm.toLowerCase();
  const displayedVendors = showAll
    ? vendors
    : vendors.filter((v) => selectedVendorIds.includes(v.ServiceProvId));

  const chunkSize = isSmallScreen ? 5 : 10;
  const vendorChunks = Array.from(
    { length: Math.ceil(displayedVendors.length / chunkSize) },
    (_, index) => displayedVendors.slice(index * chunkSize, (index + 1) * chunkSize)
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          width: isSmallScreen ? "80%" : "800px",
          maxWidth: isSmallScreen ? "80%" : "95%",
          margin: "auto",
          minHeight: isSmallScreen ? "auto" : "500px",
          maxHeight: isSmallScreen ? "80vh" : "auto",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: isSmallScreen ? "center" : "left",
          fontSize: isSmallScreen ? "1.5rem" : "1.5rem",
          py: isSmallScreen ? 2 : 1,
        }}
      >
        Allocate Vendors for {formData.TktCategoryName || "Category"}
      </DialogTitle>

      <DialogContent dividers sx={{ px: isSmallScreen ? 2 : 3, py: isSmallScreen ? 2 : 1 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search vendors..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={{
            mb: isSmallScreen ? 3 : 2,
            maxWidth: isSmallScreen ? "100%" : undefined,
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#635bff" },
              "&:hover fieldset": { borderColor: "#4e47cc" },
              fontSize: isSmallScreen ? "1.1rem" : "1rem",
            },
            "& .MuiInputLabel-root": {
              fontSize: isSmallScreen ? "1.1rem" : "1rem",
            },
          }}
        />
        {displayedVendors.length === 0 ? (
          <Typography
            variant="body2"
            sx={{
              textAlign: isSmallScreen ? "center" : "left",
              py: 2,
              fontSize: isSmallScreen ? "1.1rem" : "1rem",
            }}
          >
            No Selected Vendors Found
          </Typography>
        ) : (
          <Box sx={{ maxHeight: isSmallScreen ? "50vh" : "400px", overflowY: "auto", overflowX: "hidden" }}>
            <Grid container spacing={isSmallScreen ? 0.5 : 2} justifyContent={isSmallScreen ? "center" : "flex-start"}>
              {vendorChunks.map((chunk, idx) => (
                <Grid item xs={12} sm={6} md={3.5} key={idx}>
                  <FormGroup>
                    {chunk.map((vendorItem) => {
                      const isMatch =
                        lowerSearchTerm &&
                        vendorItem.ServiceProvName.toLowerCase().includes(lowerSearchTerm);
                      return (
                        <FormControlLabel
                          key={vendorItem.ServiceProvId}
                          control={
                            <Checkbox
                              checked={tempSelectedVendorIds.includes(vendorItem.ServiceProvId)}
                              onChange={() => handleToggleTempVendor(vendorItem.ServiceProvId)}
                              sx={{
                                padding: isSmallScreen ? "6px" : "4px 8px",
                              }}
                            />
                          }
                          label=


                          // vendorItem.ServiceProvName
                          // <Tooltip
                          //   title={vendorItem.ServiceProvName || "N/A"}
                          //   placement="top-start"
                          //   arrow
                          //   sx={{
                          //     fontSize: isSmallScreen ? "1.1rem" : "1rem",
                          //   }}
                          // >
                          //   <Typography
                          //     sx={{
                          //       fontSize: isSmallScreen ? "1.1rem" : "1rem",
                          //       maxWidth: isSmallScreen ? "240px" : "200px",
                          //       overflow: "hidden",
                          //       textOverflow: "ellipsis",
                          //       whiteSpace: "nowrap",
                          //       paddingRight: "12px",
                          //     }}
                          //   >
                          //     {vendorItem.ServiceProvName || "N/A"}
                          //   </Typography>
                          // </Tooltip>
                          {isSmallScreen ? (
                            <Typography
                              sx={{
                                fontSize: "1.1rem",
                                whiteSpace: "normal",         // allow wrapping
                                wordBreak: "break-word",      // break long words if needed
                                lineHeight: 1.3,
                                maxWidth: "100%",             // full width on small screen
                              }}
                            >
                              {vendorItem.ServiceProvName || "N/A"}
                            </Typography>
                          ) : (
                            <Tooltip
                              title={vendorItem.ServiceProvName || "N/A"}
                              placement="top-start"
                              arrow
                              sx={{
                                fontSize: "1rem",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "1rem",
                                  maxWidth: "200px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  paddingRight: "12px",
                                }}
                              >
                                {vendorItem.ServiceProvName || "N/A"}
                              </Typography>
                            </Tooltip>
                          )}

                          sx={{
                            backgroundColor: isMatch ? "rgba(99, 91, 255, 0.2)" : "transparent",
                            borderRadius: 1,
                            display: "flex",
                            alignItems: "center",
                            m: 0,
                            py: isSmallScreen ? 0.1 : 0,
                            px: isSmallScreen ? 0.5 : 0,
                            whiteSpace: isSmallScreen ? "normal" : "nowrap",
                            "& .MuiTypography-root": {
                              fontSize: isSmallScreen ? "1.1rem" : "1rem",
                            },
                          }}
                        />
                      );
                    })}
                  </FormGroup>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: isSmallScreen ? "center" : "flex-end",
          gap: isSmallScreen ? 0.5 : 1,
          px: isSmallScreen ? 1 : 3,
          py: isSmallScreen ? 0.5 : 1.5,
          flexWrap: "nowrap",
          "& > :not(:last-child)": {
            mr: isSmallScreen ? 0.5 : undefined,
          },
          paddingRight: '22px'
        }}
      >
        <FormControlLabel
          control={<Checkbox checked={showAll} onChange={onToggleShowAll} />}
          label="Display All"
          sx={{
            m: 0,
            "& .MuiTypography-root": {
              fontSize: isSmallScreen ? "1.1rem" : "1rem",
            },
            flex: isSmallScreen ? "1 1 120px" : "none",
            minWidth: isSmallScreen ? "120px" : "auto",
          }}
        />
        <Button
          onClick={handleSave}
          variant="contained"
          sx={{
            flex: isSmallScreen ? "1 1 70px" : "none",
            minWidth: isSmallScreen ? "70px" : "auto",
            backgroundColor: "#635bff",
            "&:hover": { backgroundColor: "#4e47cc" },
            fontSize: isSmallScreen ? "1rem" : "1rem",
            py: isSmallScreen ? 0.5 : 0.5,
            px: isSmallScreen ? 1 : undefined,
          }}
        >
          Save
        </Button>
        <Button
          onClick={handleClose}
          variant="outlined"
          sx={{
            flex: isSmallScreen ? "1 1 70px" : "none",
            minWidth: isSmallScreen ? "70px" : "auto",
            borderColor: "#635bff",
            color: "#635bff",
            "&:hover": { borderColor: "#4e47cc", color: "#4e47cc" },
            fontSize: isSmallScreen ? "1rem" : "1rem",
            py: isSmallScreen ? 0.5 : 0.5,
            px: isSmallScreen ? 1 : undefined,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog >
  );
};

export default VendorAllocationModal;